import React, {useContext, useState} from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ClearIcon from "@material-ui/icons/Clear";
import DoneIcon from "@material-ui/icons/Done";

import validatePasswordRules from "../functions/PasswordValidation";
import PasswordField from "../controls/PasswordField";
import SystemContext from "../SystemContext";
import {updateUserPassword} from "../AccessControl";
import { useTheme } from '@material-ui/core';


const PasswordChange = (props) => {

  const SystemData = useContext(SystemContext);
  const theme = useTheme();

  const currentUser = props.userName;

  const [passwordState, setPasswordState] = useState({
    userName: currentUser,
    currentPassword: "",
    newPassword: "",
    repeatNewPassword:"",
    openAlert: false,
    alertTitle: "",
    alertMessage: ""
  });

  function handleClose() {
    props.onChange();
  }

  async function changePassword (){

    if (passwordState.currentPassword === "") {
      const alertTitle = "Change Password";
      const alertMessage = "Current password must be provided when requesting password change";

      SystemData.openAlert(alertTitle, alertMessage);
      document.getElementById("currentPassword").focus();
      setPasswordState({...passwordState, openAlert: true, alertTitle, alertMessage});
      return;
    }

    const newPassword = {
      value: document.getElementById("newPasswordChange").value,
      id: "newPasswordChange"
    };

    const repeatNewPassword = {
      value: document.getElementById("repeatNewPassword").value,
      id: "repeatNewPassword"
    };

    //console.log("Change Password: user->", passwordState.userName, "Old Password->", passwordState.currentPassword, "New password->", newPassword.value);

    const response = validatePasswordRules(passwordState.currentPassword, newPassword, repeatNewPassword);
    // console.log(response);
    if (response.valid) {
      const result = await updateUserPassword(props.user.sub, props.user.name , passwordState.currentPassword, newPassword.value);
      if (result) {
        if (result.success) {
          SystemData.openAlert("", "Password Successfully Changed. Please login again with the new password.");
          props.logout({returnTo: window.location.origin});
          //props.onChange();
        }
        else {
          SystemData.openAlert("Password Change Failed", result.info);
        }
      }

    } else {
      //openAlert(response.alertTitle, response.errorText);
      SystemData.openAlert(response.alertTitle, response.errorText);
      document.getElementById(response.field).focus();
    }
  }

  function passwordChanged (field) {
    const fieldStateChanged = field => state => setPasswordState({ [field]: state.errors.length === 0 });
    return fieldStateChanged;
  }

  function renderRepeatPasswordBlock () {

    let newPassword = "";
    let passwordsMatch = "";

    if (passwordState.repeatNewPassword.length === 0 || !props.open) {
      return;
    } else {
      newPassword = document.getElementById("newPasswordChange").value;
      passwordsMatch = newPassword === passwordState.repeatNewPassword;
    }

    if (!passwordsMatch) {
      return (
        <div>
          <div className="clearfix" style={{backgroundColor: "RGBA(255,255,255,0)", marginRight:-28, marginTop:-38, width:"8%", float: "right"}}>
            <ClearIcon style={{color: "red", height:"20", weight:"solid"}}/>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="clearfix" style={{backgroundColor: "RGBA(255,255,255,0)", marginRight:-28, marginTop:-38, width:"8%", float: "right"}}>
            <DoneIcon style={{color: "green", height:"20"}}/>
          </div>
        </div>
      );
    }
  }

  const repeatPasswordMatch = renderRepeatPasswordBlock();

  return (
    <div id={"fred"}>
      <Dialog open={props.open}
              onClose={(event, reason) => {if (reason !== 'backdropClick'  && reason !== 'escapeKeyDown')  handleClose()}}
              aria-labelledby="form-dialog-title"
              // disableBackdropClick={true}
              style={{zIndex: 1005}}
      >
        <DialogTitle id="form-dialog-title">
          <div style={{clear: "both", backgroundColor: theme.palette.primary.main, padding:"10px"}}>
            Password Change
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please eneter your Current and New passwords in the fields below
          </DialogContentText>
          <TextField
            margin="normal"
            required
            fullWidth
            name="currentPassword"
            value={passwordState.currentPassword}
            label="Current Password"
            placeholder="Enter current password"
            type="password"
            id="currentPassword"
            autoFocus
            onChange={(event) => {
              const currentPassword = event.target.value;
              setPasswordState({...passwordState, currentPassword});
            }}
          />
          <div style={{ marginTop:5}} >
            <PasswordField
              fieldId="newPasswordChange"
              label="New Password"
              placeholder="Enter new password *"
              onStateChanged={(event) => {
                passwordChanged('newPassword');
              }}
              thresholdLength={6}
              minStrength={3}
              required

              id="newPasswordChange"
              name="newPasswordChange"
              value={passwordState.newPassword }
              onChange={(event) => {
                const newPassword = event.target.value;
                setPasswordState({...passwordState, newPassword});
              }}
            />
          </div>
          <TextField
            margin="normal"
            required
            fullWidth
            name="repeatNewPassword"
            value={passwordState.repeatNewPassword}
            label="Repeat New Password"
            placeholder="Repeat new password"
            type="password"
            id="repeatNewPassword"
            onChange={(event) => {
              const repeatNewPassword = event.target.value;
              setPasswordState({...passwordState, repeatNewPassword});
            }}
          />
          {repeatPasswordMatch}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={changePassword} color="primary">
            Change Password
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default PasswordChange;
